import React from "react";
import "./styles.scss";

const PaymentBottomCard = ({
  icon,
  arrowIcon,
  buttonText,
  btnVariant = "bg-white",
  onClick,
}) => {
  return (
    <div className={`payment-bottom-card ${btnVariant}`} onClick={onClick}>
      <div className="bottom-card-wrapper">
        <div className="d-flex align-items-center">
          <img src={icon} alt="" />
          <span className="bottom-card-text">{buttonText}</span>
        </div>
        <img
          src={arrowIcon}
          alt=""
          className="payment-bottom-card-right-icon"
        />
      </div>
    </div>
  );
};

export default PaymentBottomCard;
